import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useSEO } from "../hooks/useSEO";

const PaymentFailed = () => {
  const [params] = useSearchParams();
  const orderId = params.get("order") || "";
  const token = params.get("token") || "";

  useSEO({
    title: "Payment cancelled",
    description: "Sterling Bio Pay-by-Bank payment cancelled — you can retry from your order page.",
    path: "/payment/failed",
  });

  return (
    <div data-testid="payment-failed-page" className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
      <XCircle className="w-14 h-14 text-[#B91C1C] mx-auto" />
      <h1
        className="mt-6 text-4xl font-semibold text-[#1B3A5C] tracking-tight"
        style={{ fontFamily: "Outfit" }}
      >
        Payment not completed
      </h1>
      <p className="mt-4 text-[#475569]">
        Your bank did not confirm the payment. This can happen if you cancelled inside your bank
        app, the session timed out, or the transfer was rejected. No funds have been taken and your
        order is still reserved — you can safely try again.
      </p>
      <div className="mt-10 flex items-center justify-center gap-6">
        {orderId ? (
          <Link
            data-testid="retry-payment-link"
            to={`/order/${orderId}?token=${encodeURIComponent(token)}`}
            className="inline-flex items-center gap-2 bg-[#1B3A5C] hover:bg-[#2C8C9C] text-white px-5 py-3 text-sm font-medium tracking-wide transition-colors"
          >
            Retry payment
          </Link>
        ) : null}
        <Link to="/products" className="text-sm text-[#2C8C9C] sb-link-underline">
          ← Continue browsing
        </Link>
      </div>
    </div>
  );
};

export default PaymentFailed;
